const AUDITUDE_DEFAULTS = {
    basePath: 'https://manifest.auditude.com/auditude/variant',
    zoneID: '131829',
    clientType: '1000015',
    manifestType: 'm3u8',
    assetTag: 'ac217921a4a853e52310ebc459eef367', // md5 hash of 'vast_Comedy'
    ptCueFormat: 'turner',
    ptToken: true,
    ptTrackingMode: 'simplesstm',
    ptTrackingVersion: 'v2',
    ptDebug: false,
    ptLiveTimeline: 'B,60.0,1,p;',
    adobeStreamID: 'AS-desktop-streams',
    advertisingID: '084D2F97-D6A5-41C6-90BB-4CDDE192ACBB'
}

export default AUDITUDE_DEFAULTS;


// WEBPACK FOOTER //
// ./src/ads/defaults/Auditude.js